import { Component, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FileSystemFileEntry, NgxFileDropEntry } from "ngx-file-drop";
import { DealStateProvider } from "src/app/providers/dealstate.provider";
import { RMAProvider } from "src/app/providers/rma.provider";
import { LogService } from "src/app/services";

@Component({
  selector: "app-rma-parsar",
  templateUrl: "./dealstate-parser.component.html",
  styleUrls: ["./dealstate-parser.component.scss"],
})
export class DealStateParserComponent implements OnInit {
  loading: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  subscription: any;
  errorMessage: string = "";
  selectedVersion: string | null = null;
  importSummary: { total: number; inserted: number; updated: number; failed: number } | null = null;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private dealStateProvider: DealStateProvider,
    private logService: LogService
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === "esc") this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.isSuccess = false;
  }

  fileDropped(files: NgxFileDropEntry[]): void {
    const droppedFile = files.find((f) => f.fileEntry.isFile);
    if (!droppedFile) {
      this.isError = true;
      this.errorMessage = "Please drop a valid file.";
      return;
    }

    this.loading = true;
    this.isError = false;
    this.errorMessage = "";
    this.importSummary = null;

    // Read the file first, then upload. fileEntry.file() is async, so the POST
    // must happen inside the callback — otherwise the request goes out before
    // the file is appended and the server receives an empty upload.
    const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
    fileEntry.file((file: File) => {
      const formData = new FormData();
      formData.append("files", file);
      this.upload(formData);
    });
  }

  private upload(formData: FormData): void {
    let request$;
    if (this.selectedVersion === "version1") {
      request$ = this.dealStateProvider.postDealStateV1(formData);
    } else if (this.selectedVersion === "version2") {
      request$ = this.dealStateProvider.postDealStateV2(formData);
    } else {
      request$ = this.dealStateProvider.postDealStateV3(formData);
    }

    request$.subscribe(
      (data) => this.handleResponse(data),
      (err) => this.handleError(err)
    );
  }

  private handleResponse(data: any): void {
    this.loading = false;
    if (data && data.success) {
      this.isSuccess = true;
      this.importSummary = data.result || null;
    } else {
      this.isError = true;
      this.errorMessage =
        data?.error?.txt || "Something went wrong! Please try again.";
    }
  }

  private handleError(err: any): void {
    this.logService.error(err);
    this.loading = false;
    this.isError = true;
    // Keep the modal open so the user can actually read the error.
    this.errorMessage =
      err?.error?.error?.txt || "Something went wrong! Please try again.";
  }
}
